(function() {
  'use strict';

  function initStickyBar() {
    const stickyBar = document.getElementById("stickyAtcBar");
    const mainAtcBtn = document.querySelector("form[action*='/cart/add'] button[type='submit']");

    if (!stickyBar || !mainAtcBtn) return;

    // Dynamically set top offset based on header height
    const header = document.querySelector('[data-site-header]') || document.getElementById('custom-header');
    if (header) {
      var lastHeight = 0;
      var updateTop = function() {
        var h = header.offsetHeight;
        if (h !== lastHeight) {
          lastHeight = h;
          stickyBar.style.setProperty('--sticky-atc-top', h + 'px');
        }
      };
      updateTop();
      window.addEventListener('resize', updateTop);
      window.addEventListener('scroll', updateTop, { passive: true });
    }

    let hasScrolledPast = false; // prevent bar from showing immediately
    let hasBeenVisible = false; // track if button has been visible at least once

    // Create intersection observer to track Add to Cart button visibility
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Button is visible -> hide sticky bar, mark as seen, and reset state
            hasBeenVisible = true;
            hasScrolledPast = false;
            stickyBar.classList.remove("active");
          } else {
            // Button is out of view -> only show if user has scrolled past it downward
            if (hasBeenVisible && window.scrollY > 200) {
              // Check if button is above viewport (we scrolled past it) or below (we're above it)
              if (entry.boundingClientRect.top < 0) {
                // Button is above viewport - show sticky bar
                hasScrolledPast = true;
                stickyBar.classList.add("active");
              } else {
                // Button is below viewport (we're above it) - hide sticky bar
                stickyBar.classList.remove("active");
              }
            }
          }
        });
      },
      {
        root: null,
        threshold: 0,
      }
    );

    observer.observe(mainAtcBtn);

    // Handle scroll reset when at top of page
    window.addEventListener("scroll", () => {
      // Hide bar when scrolled to the very top (within 100px)
      if (window.scrollY < 100) {
        stickyBar.classList.remove("active");
      }
    });
  }

  function initButtonSync() {
    const stickyAtcBtn = document.getElementById("stickyAtcBtn");
    const mainAtcBtn = document.querySelector("form[action*='/cart/add'] button[type='submit']");
    const variantSelect = document.querySelector("select[name='id']");

    function syncAtcState() {
      if (!stickyAtcBtn || !mainAtcBtn) return;

      const disabled = mainAtcBtn.disabled || mainAtcBtn.hasAttribute("disabled");

      // Sync disabled state + label
      stickyAtcBtn.disabled = disabled;
      stickyAtcBtn.textContent = disabled ? "Sold Out" : "Add to Cart";

      // Use CSS classes instead of direct style manipulation
      if (disabled) {
        stickyAtcBtn.classList.add('disabled');
      } else {
        stickyAtcBtn.classList.remove('disabled');
      }
    }

    // Run once on load
    syncAtcState();

    // Update if variant changes (Shopify triggers 'change' on variant select)
    if (variantSelect) {
      variantSelect.addEventListener("change", () => {
        // Wait briefly for Shopify's variant update logic to finish
        setTimeout(syncAtcState, 150);
      });
    }

    // Update if the main ATC button changes dynamically
    const observer = new MutationObserver(syncAtcState);
    if (mainAtcBtn) {
      observer.observe(mainAtcBtn, { attributes: true, attributeFilter: ["disabled"] });
    }

    // Click behavior — forward to main ATC only if enabled
    stickyAtcBtn.addEventListener("click", () => {
      if (!stickyAtcBtn.disabled && mainAtcBtn) {
        mainAtcBtn.click();
      }
    });
  }

  // Initialize everything
  function init() {
    initStickyBar();
    initButtonSync();
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize in Shopify theme editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();
